import React from 'react';
import { BlockWrapper } from '../Preview';
import { generateCss, generateEvent, generateStyle } from '../../functions/sortableFunctions';
const Loop = ({ block, ...props }: any) => {
    const [loopData, setLoopData] = React.useState((props.nextJs && block?.data?.ssr) ? props?.data?.[block?.id] : null);
    const [previousData, setPreviousData] = React.useState((props.loopData || props.setLoopData || props.singleData || props.setSingleData) ? {
        ...props.previousData,
        [Object.keys(props.previousData ?? {}).length + 1]: {
            singleData: props.singleData,
            setSingleData: props.setSingleData,
            loopData: props.loopData,
            setLoopData: props.setLoopData,
        }
    } : null);

    React.useEffect(() => {
        if (!block?.data?.ssr) {
            generateEvent({
                props: {
                    ...props,
                    block
                },
                event: "onLoad",
                loopData,
                setLoopData,
                previousData,
                setPreviousData
            });
        }
    }, (block?.data?.dependencies ? eval(block.data.dependencies) : []));

    React.useEffect(() => {
        if (props.setSingleData || props.loopData || props.setLoopData || props.singleData) {
            setPreviousData(() => {

                return {
                    ...props.previousData,
                    [Object.keys(props.previousData ?? {}).length + 1]: {
                        singleData: props.singleData,
                        setSingleData: props.setSingleData,
                        loopData: props.loopData,
                        setLoopData: props.setLoopData,
                    }
                }
            });
        }
    }, [props.loopData, props.previousData, props.singleData]);

    return (
        React.createElement(
            block?.data?.type ?? "div",
            {
                id: block.id,
                style: generateStyle({
                    props: {
                        ...props,
                        block
                    }
                }),
                className: generateCss({
                    props: {
                        ...props,
                        block: block
                    },
                }),
                onClick: block.events?.onClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onClick"
                    });
                } : null,
                onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onDoubleClick"
                    });
                } : null,
                onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onContextMenu"
                    });
                } : null,
                onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseOver"
                    });
                } : null,
                onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseLeave"
                    });
                } : null
            },
            (Array.isArray(loopData) ? loopData : [])?.slice(0, block?.data?.numberOfItemsToDisplay)?.map((singleData, index): any => {
                if (block?.data?.filter ? eval(block?.data?.filter) : true) {
                    return <BlockWrapper
                        {...props}
                        key={index}
                        block={block?.children?.[0]}
                        previousData={previousData}
                        loopData={loopData}
                        setLoopData={setLoopData}
                        singleData={singleData}
                        index={index}
                    />
                }
            })
        )
    );
}

export default Loop;